import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { environment } from '../../../environments/environment';

@Injectable()
export class ClientService {

  constructor(public http: HttpClient) {

  }

  getColor(id = null): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/admin/color' + ((id) ? ("/" + id) : ""), this.getHeaders());
  }

  getClientData() {
    let id = JSON.parse(sessionStorage.getItem("loggedUser")).data.client_id;
    return this.http.get(environment.baseUrl + '/api/v2/admin/asap-client/' + id, this.getHeaders());
  }

  public updateConfig(data) {
    return this.http.post(environment.baseUrl + '/api/v21/admin/asap-client/update-config', data, this.getHeaders());
  }

  putColor(config: any, id = null): Observable<any> {
    const body = {
      config: config
    };
    return this.http.put(environment.baseUrl + '/api/v2/admin/color' + ((id) ? ("/" + id) : ""), body, this.getHeaders());
  }

  getHeaders(): { headers: HttpHeaders } {
    const token = sessionStorage.getItem('token');
    const headerOptions = {
      'Authorization': token,
      'Accept': 'application/json'
    };
    return { headers: new HttpHeaders(headerOptions) };
  }

}



// WEBPACK FOOTER //
// ./src/app/@core/services/client.service.ts